import { CascadeMenu } from '@aibees/elephant/components/cascade-menu';
import { ROUTES as R } from '@aibees/elephant/router';
import { LabelGrouping } from '@aibees/elephant/types/label';
import { IconButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils/class-names';
import { memo, useCallback, useMemo } from 'react';
import { type ListSearchTableActionProps as Props } from './types';

const CASCADE_ITEMS = [
  {
    key: 'include',
    label: 'Include',
    icon: 'add-circle-outlined' as const,
    iconColor: 'primary.500',
  },
  {
    key: 'exclude',
    label: 'Exclude',
    icon: 'stop-sign' as const,
    iconColor: 'error.500',
  },
  {
    key: 'include_and',
    label: 'Include (AND)',
    icon: 'add-task' as const,
    iconColor: 'warning.500',
  },
];

const URL_KEY: Record<string, { company: string; people: string }> = {
  include: { company: 'companies_include_list', people: 'people_include_list' },
  exclude: { company: 'companies_exclude_list', people: 'people_exclude_list' },
  include_and: {
    company: 'companies_all_of_list',
    people: 'people_all_of_list',
  },
};

export const ListSearchTableAction = memo(({ className, item }: Props) => {
  const handleSelect = useCallback(
    (parentKey: string) => {
      const subKey =
        item.grouping === LabelGrouping.COMPANY ? 'company' : 'people';
      const urlKey = URL_KEY[parentKey]?.[subKey];
      if (!urlKey) return;
      const route = subKey === 'company' ? R.searchCompany : R.searchPeople;
      const value = encodeURIComponent(
        `${item.name}::${encodeURIComponent(item.id)}`
      );
      window.open(`${route}?${urlKey}=${value}`, '_blank');
    },
    [item]
  );

  const trigger = useMemo(
    () => <IconButton icon="eye-outlined" variant="outlined" size="xsmall" />,
    []
  );

  return (
    <CascadeMenu
      className={classnames('ListSearchTableAction', className)}
      items={CASCADE_ITEMS}
      onSelect={handleSelect}
      buttonElement={trigger}
    />
  );
});

ListSearchTableAction.displayName = 'ListSearchTableAction';
